// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body {\n    color: #f0f0f0;\n    font-family:Monospace;\n    font-size:13px;\n    text-align:center;\n\n    background-color: #000000;\n    margin: 0px;\n    overflow: hidden;\n}\n\n#info {\n    position: absolute;\n    top: 0px; width: 100%;\n    padding: 5px;\n}\n\na {\n\n    color: #0080ff;\n}\n\n.table1 {\n    border: 1px solid #606060;\n    border-collapse: collapse;\n}\n.table1 th, .table1 td {\n    border: 1px solid #606060;\n}", ""]);
// Exports
module.exports = exports;
